<template>
  <v-card flat tile class="overflow-y-auto">
   
    <v-toolbar height="32" outlined color="Neutral" flat>
      <v-spacer></v-spacer>
      <v-btn color="pageHeader" text class="vueexcelbtn">
        <vue-excel-xlsx :disabled="getSurveyResponseResultData.length ? false : true" :data="getSurveyResponseResultData"
          :columns="headingColumns" :file-name="filename" :file-type="'xlsx'" :sheet-name="'Responses'">
          <v-icon :color="getSurveyResponseResultData.length ? 'green darken-2' : 'grey darken-2'">mdi-microsoft-excel</v-icon>
          {{ $t("poll.lblOpenExcel") }}
        </vue-excel-xlsx>
      </v-btn>
    </v-toolbar>
    <v-divider style="border-color: gray"></v-divider>
    
    <template v-for="(question, index) in questionsDetails">
      <div :key="index">
        <v-row class="mt-4 pb-0" no-gutters>
          <v-col
            md="11"
            class="pl-4 text-h6 font-weight-regular"
            style="display: inline-block; word-break: normal"
            >
            {{ index + 1 }}. 
            <span v-html="questionText(question.question)" ></span>
            <v-tooltip top v-if="question.isMandatory">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                v-on="on" v-if="question.isMandatory" style="color: red" class="ml-1">
                  *
                </span>
              </template>
              <span>{{ $t("poll.ruleRequired") }} </span>
            </v-tooltip>
          </v-col>
          <v-col
              md="1"
              class="text-center"
            >
              <v-btn
              icon
                color="grey"
                small
                depressed
                @click="toggleExpand(question.id)"
                >
                <v-icon>
                  {{ expandedIds.includes(question.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </v-btn>
            </v-col>
        </v-row>
        <transition
          name="slide"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
        <v-card-text v-if="!expandedIds.includes(question.id)">
          <likert-response-chart v-if="question.type === 'likert'" :question="question" :countOptionAnswers="likertResponseData[question.id]
              ? likertResponseData[question.id].optionCounts
              : []
            " :responseCount="likertResponseData[question.id]
      ? likertResponseData[question.id].count
      : 0
    "></likert-response-chart>
          <text-response v-if="question.type === 'textType'" :question="question"
            :textResponse="textResponses[question.id]">
          </text-response>
          <rating-response v-else-if="question.type === 'rating'" :question="question"
            :ratingData="ratingData[question.id]"></rating-response>
          <v-row v-else-if="question.type === 'choice'" no-gutters>
            <v-col cols="8" no-gutters>
              <v-list>
                <v-list-item v-for="(option, i) in question.options" :key="`list_${option}_${i}`" class="group-item-list">
                  <!-- {{ option }} -->
                  <v-list-item-content class="font-weight-medium">
                    <v-layout>
                      <v-row align="center">
                        <v-col cols="auto">
                          <v-row no-gutters justify="start">
                            <v-sheet :rounded="radius" :color="option.fill" height="20" width="20"></v-sheet>
                          </v-row>
                        </v-col>
                        <v-col cols="auto">
                          <v-row no-gutters justify="start"><span class="expire-label" style="overflow-wrap: anywhere">{{
                            option.text }}
                            </span></v-row>
                        </v-col>
                        <v-col cols="auto">
                          <v-row no-gutters justify="start" v-if="countOptionAnswers[question.id]">
                            {{
                              countOptionAnswers[question.id].optionCounts[
                                option.value
                              ]
                            }}
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-layout>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="4">
              <survey-response-chart :question="question" v-if="countOptionAnswers[question.id]" :countOptionAnswers="countOptionAnswers[question.id].optionCounts
                " :responseCount="countOptionAnswers[question.id]
      ? countOptionAnswers[question.id].count
      : 0
    " />
            </v-col>
          </v-row>
        </v-card-text>
      </transition>
        <v-divider v-if="index < questionsDetails.length - 1" class="mx-4"></v-divider>
        <v-divider v-if="index === questionsDetails.length - 1"></v-divider>
      </div>
    </template>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LikertResponseChart from "./LikertResponseChart.vue";
import RatingResponse from "./RatingResponse.vue";
import TextResponse from "./TextResponse.vue";
import SurveyResponseChart from "./SurveyResponseChart.vue";
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import _ from "lodash";
import { formatDate } from "@/utils/util";

Vue.use(VueExcelXlsx);
export default {
  components: {
    SurveyResponseChart,
    RatingResponse,
    LikertResponseChart,
    TextResponse,
  },
  name: "SurveyResponse",
  props: {
    surveyQuestions: {
      type: [Object, Array],
    },
    tab: {
      type: String,
      default: 'question',
    },
  },
  computed: {
    ...mapState({
      surveyResponseResult: (state) => state.poll.surveyResponseResult,
      surveyCompairResult: (state) => state.poll.surveyCompairResult,
    }),

    questionsDetails() {
      return this.surveyResponseData;
    },
    surveyResponseSummaryResult(){
      if(this.tab === "result-summary" && this.surveyCompairResult.length){
        return this.surveyCompairResult;
      }
      return this.surveyResponseResult;
    },
    ratingResponses() {
      let responseList = [];
      let index = 1;
      this.surveyResponseData.forEach((quest) => { });
      if (responseList.length > 1 && !this.selectedResponse) {
        this.selectedResponse = responseList[0];
      }
      return responseList;
    },

    filename() {
      return this.surveyQuestions?.title;
    },
    headingColumns() {
      const headers = [];
       // Ensure surveyQuestions exists and has questions
      if (!this.surveyQuestions || !this.surveyQuestions.questions) {
        return [];
      }
      const exlColumns = [
        {
          label: this.$t("poll.lblPollExcelId"),
          field: "id",
        },
        {
          label: this.$t("poll.lblPollExcelSubmitDate"),
          field: "submitDate",
        },
        {
          label: this.$t("poll.lblPollExcelUserId"),
          field: "userid",
        },
      ];
      this.surveyQuestions.questions.forEach((question, index) => {
        if (question.type === "likert") {
          question.options.statement.forEach((stmt) => {
            headers.push({
              label: index + 1 + ". " + question.question + "\n" + stmt.text,
              field: index + 1 + stmt.text,
            });
          });
        } else {
          headers.push({
            label: index + 1 + ". " + question.question,
            field: "Question" + (index + 1),
          });
        }
      });
      return [...exlColumns, ...headers];
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    getSurveyResponseResultData() {
      return this.surveyResponseResultData;
    },
    locale() {
      return this.$i18n.locale;
    },
    displayDateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy h:mm aaa" : "yyyy-MM-dd HH:mm";
    },
  },
  data: () => ({
    surveyResponseData: [],
    textResponses: {},
    countOptionAnswers: {},
    likertResponseData: {},
    ratingData: {},
    radius: "circle",
    menuMaxHeight: `${60 * 5 + 4}px`,
    data: [],
    surveyResponseResultData: [],
    expandedIds: []
  }),
  watch: {
    "surveyQuestions.id": {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue) {
          await this.analyseResponse(newValue);
          if(newValue && oldValue){
            const rowData = await this.getRowData();
            this.surveyResponseResultData = rowData;
          }
        }
      },
    },
    "surveyResponseResult": {
      immediate: true,
      async handler() {
          if(this.$route.params.id){
            await this.analyseResponse(this.$route.params.id);
            const rowData = await this.getRowData();
            this.surveyResponseResultData = rowData;
          }
      },
    },
  },

  async mounted() {
    const rowData = await this.getRowData();
    this.surveyResponseResultData = rowData;
  },
  async created() {
    this.$root.$on("refresh-signalR", async () => {
      await this.analyseResponse(this.$route.params.id);
    });
  },
  beforeDestroy() {
    this.$root.$off("refresh-signalR");
  },
  methods: {
    ...mapActions({
      getResponseBySurveyId: "poll/getResponseBySurveyId",
    }),
    formatDate,
    async updateRespondentResult() {
      const surveyQuestionsData = _.cloneDeep(this.surveyQuestions);
      if(this.surveyResponseSummaryResult && this.surveyResponseSummaryResult.length > 0){
          this.surveyResponseSummaryResult.forEach((surveyResponse) => {
            surveyQuestionsData.questions.forEach((question) => {
              const data = surveyResponse.questionAnswers.findIndex(
                (x) => x.questionId === question.id
              );
              if (data > -1) {
                question.selectedAnswer =
                  surveyResponse.questionAnswers[data].answer;
              }
            });
          });
      }
      
      this.surveyResponseData = surveyQuestionsData
        ? surveyQuestionsData.questions
        : [];
    },
    questionText(html){
      const htmlContent = html.replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
      const content = htmlContent ? htmlContent.replace(/\n/g, '<br>') : ''
      return this.$sanitizeHtml(content)
    },
    toggleExpand(id) {
      const index = this.expandedIds.indexOf(id);
      if (index === -1) {
        // Add the ID if not present
        this.expandedIds.push(id);
      } else {
        // Remove the ID if already present
        this.expandedIds.splice(index, 1);
      }
    },
    beforeEnter(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    },
    enter(el, done) {
      const height = el.scrollHeight;
      el.style.height = `${height}px`;
      el.style.opacity = '1';
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      setTimeout(() => {
        el.style.height = 'auto';
        done();
      }, 300);
    },
    leave(el, done) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.opacity = '1';
      setTimeout(() => {
        el.style.height = '0';
        el.style.opacity = '0';
        el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
        done();
      }, 0);
    },
    async analyseResponse(id) {
      const data = this.surveyResponseSummaryResult;
      let temp = [];
      let resCount = data.length;
      if(data && data.length > 0){
          data.forEach((answer) => {
            const questions = answer.questionAnswers.map((a) => a.answer);
            answer.questionAnswers.forEach((list) => {
              if (Array.isArray(list.answer)) {
                list.answer.forEach((q) => {
                  temp.push({
                    answer: q,
                    type: list.type,
                    questionId: list.questionId,
                    userid: answer.userid
                  });
                });
              } else {
                temp.push({
                  answer: list.answer,
                  type: list.type,
                  questionId: list.questionId,
                  userid: answer.userid
                });
              }
            });
          });
        }
      
      const likertQuestionAnswerRes = temp.filter((t) => t.type == "likert" && t.answer.value !== null);
      const uniqueRes = _.uniqBy(likertQuestionAnswerRes, function (e) {
            return e.userid;
          });
        resCount = uniqueRes ? uniqueRes.length : 0
      this.countOptionAnswers = {};
      this.ratingData = {};
      this.textResponses = {};
      let total = {};
      let responseCount = {};
      let countOptions = {};
      let textIndex = 0;
      let textRes = [];
      let likertResponseCount = {};
      let likertResponse = {};
      let likertValues = [];
      const questionAnswerResponse = temp.filter((t) => t.answer !== null);
      questionAnswerResponse.forEach((element) => {
        responseCount[element.questionId] =
          (responseCount[element.questionId] || 0) + 1;

        let count = responseCount[element.questionId];

        if (element.type === "choice") {
          countOptions[element.answer] =
            (countOptions[element.answer] || 0) + 1;

          this.countOptionAnswers[element.questionId] = {
            optionCounts: countOptions,
            count: count,
          };
        } else if (element.type === "likert") {
          likertResponseCount[element.questionId] =
            (likertResponseCount[element.questionId] || 0) + 1;

          likertValues.push({
            text: element.answer.text,
            value: element.answer.value,
            questionId: element.questionId,
          });
          //likertResponse[element.answer.text] =
          this.likertResponseData[element.questionId] = {
            optionCounts: likertValues.filter(
              (f) => f.questionId === element.questionId
            ),
            count: resCount,
          };
        } else if (element.type === "rating") {
          total[element.questionId] =
            (total[element.questionId] || 0) + element.answer;

          this.ratingData[element.questionId] = {
            count: count,
            avg: (total[element.questionId] / count).toFixed(2),
          };
        } else if (element.type === "textType") {
          textRes.push({
            questionId: element.questionId,
            text: element.answer,
          });
          this.textResponses[element.questionId] = textRes
            .filter((f) => f.questionId === element.questionId)
            .map((a) => a.text);
        } else {
          countOptions[element.answer] =
            (countOptions[element.answer] || 0) + 1;

          this.countOptionAnswers[element.questionId] = {
            optionCounts: countOptions,
            count: count,
          };
        }
      });
      await this.updateRespondentResult();
    },
    async getRowData() {
      let index = 1;
      const rowData = [];
      if(this.surveyQuestions && this.surveyResponseSummaryResult && this.surveyResponseSummaryResult.length > 0){
        await this.surveyResponseSummaryResult.forEach((res) => {
        let js = {};
        js.id = index.toString();
        const submitDate = this.formatDate(
          new Date(res.submitDate),
          this.displayDateFormat
        );
        js.submitDate = submitDate;
        const useName = res.userName
          ? `${res.userName} (${res.userid})`
          : res.userid;
        if ( "isAnonymous" in this.surveyQuestions &&
          this.surveyQuestions.isAnonymous
        ) {
          js.userid = this.$t("poll.lblUserRespondent", { number: index });
        } else {
          js.userid = useName;
        }

        this.surveyQuestions.questions.forEach((question, index) => {
          const queIndex = index + 1;
          const data = res.questionAnswers.findIndex(
            (x) => x.questionId === question.id
          );
          if (data > -1) {
            if (question.type === "likert") {
              const anwers = res.questionAnswers[data].answer ? res.questionAnswers[data].answer : [];
              anwers.forEach((ans) => {
                const ansdata = question.options.options.findIndex(
                  (x) => x.value === ans.value
                );
                if (ansdata > -1) {
                  const comment = ans.comment ? `Comment: ${ans.comment}` : "";
                  const text = `${question.options.options[ansdata].text}${comment ? `  \n${comment}` : ""}`;
                  
                  js[queIndex + ans.text] = text;
                }
                
              });
            } else if (
              question.type === "choice" &&
              question.isMultipleAnswer === false
            ) {
              const ansdata = question.options.find(
                (x) => x.value === res.questionAnswers[data].answer
              );
              if (ansdata) {
                js["Question" + queIndex] = ansdata.text;
              }
            } else if (
              question.type === "choice" &&
              question.isMultipleAnswer === true
            ) {
              let str = [];
              const anwers = res.questionAnswers[data].answer ? res.questionAnswers[data].answer : [];
              anwers.forEach((ans) => {
                const ansdata = question.options.find((x) => x.value === ans);
                if (ansdata) {
                  str.push(ansdata.text);
                }
              });
              js["Question" + queIndex] = str.join(", ");
            } else {
              js["Question" + queIndex] = res.questionAnswers[data].answer
                ? res.questionAnswers[data].answer.toString()
                : "";
            }
          }
        });
        rowData.push(js);
        index = index + 1;
      });
      
      }
      return rowData;
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid gray;
}

.group-item-list {
  margin-top: 2px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}

.expire-label {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.vote-label {
  font-size: 0.688rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: darkblue;
}

.v-list-item-group .v-list-item--active {
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
}

.vueexcelbtn /deep/ button:disabled{
  background-color: #e0e0e0;  /* light grey background */
  color: #9e9e9e;             /* grey text */
  border-color: #ccc;         /* optional: adjust border too */
  cursor: not-allowed;
}
</style>